import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  //styleUrls: ['./app-footer.component.scss']
})
export class AppFooterComponent implements OnInit {

  social: any;

  constructor(
    public route: RoutingService,
    public api: RestapiService,
  ) { }

  ngOnInit(): void {
    this.loadSocialData();
  }

  loadSocialData() {
    this.api.getdata('websocial', { per_page: 1000 })
      .subscribe(res => {
       // console.log('res websocial', res);
        if (res.status === true) {
          this.social = {};
          this.api.social = {};
          res.result.data.forEach(el => {

            this.social[el.name] = el.url;
            this.api.social[el.name] = el.url;
          });
        //  console.log('  this.api.social', this.social,   this.api.social)
        }
      });
  }

}
